export default class TabBox {
  constructor($tabBox) {
    this.$tabBox = $tabBox;

    this.init();
  }

  init() {
    this.$tabBox.addEventListener('selectTab', this.onSelectTab.bind(this));
  }

  onSelectTab(event) {
    const $currentPanel = this.$tabBox.querySelector('.js-tab-box-panel:not([hidden])');
    // Hide current panel
    if ($currentPanel) {
      $currentPanel.removeAttribute('tabindex');
      $currentPanel.setAttribute('hidden', true);

      // Find new panel
      const $panel = this.$tabBox.querySelector(event.target.getAttribute('href'));

      // Make panel visible
      $panel.removeAttribute('hidden');
    }
  }
}
